import React from "react";
// react plugin for creating charts
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";

import styles from "assets/jss/material-dashboard-react/components/chucnangStyle.js";

const useStyles = makeStyles(styles);
import PropTypes from "prop-types";
const ThongkedonvicosoTT = React.memo(function ThongkedonvicosoTT(props) {
  const classes = useStyles();
  const { phanloaisoluong } = props;
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tabledb_th}>STT</th>
          <th className={classes.tabledb_th}>Phân loại</th>
          <th className={classes.tabledb_th}>Số lượng</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        {phanloaisoluong.map((row, i) => {
          return (
            <tr key={i}>
              <td className={classes.tabledb_td}>{row["tt"]}</td>
              <td className={classes.tabledb_td}>{row["loai_donvi"]}</td>
              <td className={classes.tabledb_td_number}>
                {Number(row["soluong"]).toLocaleString()}
              </td>
            </tr>
          );
        })}
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = phanloaisoluong.length > 0 ? renderTableBody() : null;
  return (
    <div className={classes.table} style={{ height: "210px" }}>
      <table className={classes.tabledb}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

ThongkedonvicosoTT.propTypes = {
  phanloaisoluong: PropTypes.array,
};
export default ThongkedonvicosoTT;
